import React, { useContext } from "react";
import { QuestionSection, Radio } from "../../components/utility/quote";
import { navigate } from "gatsby";

import SolutionsContext from "../../contexts/solutionsContext";

import Helpdesk from "../../svgs/solutions/HelpDesk";
import Other from "../../svgs/solutions/Other";
import ProjectManagement from "../../svgs/solutions/ProjectManagement";
import Server from "../../svgs/solutions/Server";
import TechSupport from "../../svgs/solutions/TechSupport";
import Backup from "../../svgs/solutions/Backup";
import Hardware from "../../svgs/solutions/Hardware";

const Next = "/solutions/Questions/2";
const Points = [
  {
    question: "What type of service do you require?",
    progress: "20%",
    options: [
      { answer: "Helpdesk / Remote Desktop", to: Next, icon: <Helpdesk /> },
      { answer: "On-Site Technical Support", to: Next, icon: <TechSupport /> },
      {
        answer: "It Project management",
        to: Next,
        icon: <ProjectManagement />,
      },
      { answer: "Server maintenance", to: Next, icon: <Server /> },
      {
        answer: "Hardware & Software maintenance",
        to: Next,
        icon: <Hardware />,
      },
      { answer: "Backup & Disaster recovery", to: Next, icon: <Backup /> },
      { answer: "Other", to: Next, icon: <Other /> },
    ],
  },
];
export default function Question1({ title }) {
  const { que1, setQue1 } = useContext(SolutionsContext);

  return Points.map((item) => {
    return (
      <QuestionSection
        title={title}
        question={item.question}
        progress={item.progress}
      >
        {item.options.map((items) => {
          return (
            <Radio
              key={items.answer}
              icon={items.icon}
              value={items.answer}
              title={items.answer}
              isSelected={que1 === items.answer}
              onChange={(e) => {
                setQue1(e.target.value);
                navigate(items.to);
              }}
            />
          );
        })}
      </QuestionSection>
    );
  });
}
